import React from 'react';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import Lease from './Lease';

function LeaseIndex() {
  return (
    <div>
      <Navbar />
      <Lease />
      <Footer />
    </div>
  );
}

export default LeaseIndex;
